<template>
  <div>
  <div class="border p-3 shadow-sm mb-4">
    <h6 class="border-b pb-2 text-md font-bold text-gray-700">Rooms</h6>

    <div class="flex flex-col">
      <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 inline-block min-w-full sm:px-3 lg:px-8">
          <div class="overflow-hidden table-responsive">
            <table class="table">
              <thead class="border-b bg-gray-50">
                <tr>
                  <th scope="col" class="text-sm font-medium text-gray-900 px-3 py-2">
                    Room Details
                  </th>
                  <th scope="col" class="text-sm font-medium text-gray-900 px-3 py-2">
                    Nights
                  </th>
                  <th scope="col" class="text-sm font-medium text-gray-900 px-3 py-2">
                    Guests
                  </th>
                  <th scope="col" class="text-sm font-medium text-gray-900 px-3 py-2">
                    Meal Plan
                  </th>
                  <th scope="col" class="text-sm font-medium text-gray-900 px-3 py-2">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-white border-b" v-for="room in roomDetails.details" :key="room.id">
                  <td class="text-sm text-gray-900 font-light px-3 py-3 whitespace-nowrap">
                    {{ room.name }}
                  </td>
                  <td class="text-sm text-gray-900 font-light px-3 py-3 whitespace-nowrap">
                    {{ nights }}
                  </td>
                  <td class="text-sm text-gray-900 font-light px-3 py-3 whitespace-nowrap">
                    {{ room.adults }} Adult
                  </td>
                  <td class="text-sm text-gray-900 font-light px-3 py-3 whitespace-nowrap">
                    {{ mealPlan(room.meal_plan) }}
                  </td>
                  <td class="text-sm text-gray-900 font-light px-3 py-3 whitespace-nowrap">
                    KES {{ roomDetails.total_amount  }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <p class="text-right mb-0 pt-2">
      <a href="#" class="text-xs text-reserva-orange hover:none absolute bottom-6 right-4"
        @click.prevent="editBookingDetails()" v-if="!cancellationStatus">
        Edit Selection
      </a>
    </p>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2">
    <div></div>
    <div>
      <table class="table table-bordered">
        <tr>
          <th class="bg-light text-xs font-bold text-gray-900"> SUBTOTAL: </th>
          <td class="text-sm text-gray-900 font-light whitespace-nowrap"> KES {{ roomDetails.total_amount }} </td>
        </tr>
        <tr>
          <th class="bg-light text-xs font-bold text-gray-900"> AMOUNT PAID: </th>
          <td class="text-sm text-gray-900 font-light whitespace-nowrap"> KES {{ roomDetails.amount_paid }} </td>
        </tr>
        <tr>
          <th class="bg-light text-xs font-bold text-gray-900"> STATUS: </th>
          <td class="text-sm text-gray-900 font-light whitespace-nowrap"> {{ roomDetails.status_pesapal }} </td>
        </tr>
        <tr>
          <th class="bg-light text-xs font-bold text-gray-900"> PAYMENT METHOD: </th>
          <td class="text-sm text-gray-900 font-light whitespace-nowrap"> {{ roomDetails.payment_method }} </td>
        </tr>
      </table>
    </div>
  </div>
  </div>
</template>

<script>
import ManageBooking from '../../mixins/manageBooking'
import ReusableData from '../../mixins/reusableData'
import moment from 'moment'
export default {
  props: {
    cancellationStatus: ''
  },
  data () {
    return {
      roomDetails: this.$store.getters.bookingDetails
    }
  },
  methods: {
    mealPlan (item) {
      let fullName
      if (item === 'hb') {
        fullName = 'Half Board'
      } else if (item === 'fb') {
        fullName = 'Full Board'
      } else if (item === 'bo') {
        fullName = 'Bed Only'
      } else if (item === 'bb') {
        fullName = 'Bed & Breakfast'
      } else if (item === 'ai') {
        fullName = 'All Inclusive'
      } else {
        fullName = 'N/A'
      }
      return fullName
    }
  },
  computed: {
    nights () {
      const start = moment(this.roomDetails.checkin_date)
      const end = moment(this.roomDetails.checkout_date)
      // change room details
      // to check if not pay reference, then nothing was paid
      // if (!this.roomDetails.payment_reference_number) {
      //   this.roomDetails.amount_paid = 0
      //   this.roomDetails.payment_method = 'N/A'
      // }
      // end
      return end.diff(start, 'days')
    }
  },
  mixins: [ManageBooking, ReusableData]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/manageBooking/subcomponents/RoomDetails.vue